"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeQueryString = void 0;

var isEmpty = function isEmpty(o) {
  return o === undefined || o === null;
};

var stringifyArray = function stringifyArray(key, value) {
  if (value.length > 0) {
    return key + '=' + value.join(',');
  }

  return key + '=';
};

var encodeQueryString = function encodeQueryString(obj) {
  var pairs = [];
  Object.keys(obj).forEach(function (key) {
    if (!isEmpty(obj[key])) {
      if (Array.isArray(obj[key])) {
        pairs.push(stringifyArray(key, obj[key]));
        return;
      }

      pairs.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key])));
    }
  });
  return pairs.join('&');
};

exports.encodeQueryString = encodeQueryString;